<template>
  <p class="mb-0 pl-3 texto-corrido regular">{{ charsUsed }}</p>
</template>

<script>
import { characterVariables } from '@/mixins/character-variables'

export default {
  name: 'TemplateMessageTextCounter',
  mixins: [characterVariables],
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.updateCharsUsedLength(false)
  },
}
</script>
